module.exports = __webpack_public_path__ + "officialStatic/img/luxLogo.0437bd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/luxLogo.png
// module id = nERr
// module chunks = 0